import React from 'react';

import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ServiceFilters = ({ filters, onFiltersChange, language }) => {
 const categoryOptions = [
    { value: 'Orthodontie', label: 'Orthodontie' },
    { value: 'Aligneurs', label: 'Aligneurs' },
    { value: 'Consultation', label: 'Consultation' },
    { value: 'Imagerie', label: 'Imagerie' },
    { value: 'Traitement', label: 'Traitement' },
    { value: 'Maintenance', label: 'Maintenance' },
    { value: 'Production', label: 'Production' },
    { value: 'Logistique', label: 'Logistique' },
    { value: 'Autre', label: 'Autre' },
  ];

  const statusOptions = [
    { value: 'all', label: 'Tous les statuts' },
    { value: 'active', label: 'Actif' },
    { value: 'inactive', label: 'Inactif' }
  ];

  const handleFilterChange = (key, value) => {
    if (key === 'isActive') {
      if (value === 'all') {
        onFiltersChange({ ...filters, isActive: undefined });
      } else {
        onFiltersChange({ ...filters, isActive: value === 'active' });
      }
    } else {
      onFiltersChange({ ...filters, [key]: value });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Icon 
            name="Search" 
            size={20} 
            className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
          />
          <input
            type="text"
            placeholder="Rechercher un service..."
            value={filters?.search}
            onChange={(e) => handleFilterChange('search', e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        <Select
          value={filters?.category}
          onChange={(e) => handleFilterChange('category', e?.target?.value)}
          options={categoryOptions}
        />

        <Select
          value={filters?.isActive === undefined ? 'all' : filters?.isActive ? 'active' : 'inactive'}
          onChange={(e) => handleFilterChange('isActive', e?.target?.value)}
          options={statusOptions}
        />
      </div>
    </div>
  );
};

export default ServiceFilters;